import React, { FC } from 'react';
import Section from '../../../Components/Section/Section';
import Container from '../../../../../Common/Container/Container';
import MiscellaneousInformationTitle from '../../../Components/MiscellaneousInformationTitle/MiscellaneousInformationTitle';
import { MiscellaneousInformation } from '../../../../../../enums/MiscellaneousInformation';
import { IAwards, IEducation } from '../../../../../../interfaces/professional/Professional';
import BorderedListItem from '../../../Components/BorderedListItem/BorderedListItem';
import * as classes from './HeroSection.module.scss';
import cn from 'classnames';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { AdditionalInfoHeroSectionProps } from '../../../../../Sections/AdditionalInfo/HeroSection/HeroSection';

const HeroSection: FC<AdditionalInfoHeroSectionProps> = ({ education, profAssociations, awards }) => {
  const { t } = useTranslation();

  const educationMapper = (item: IEducation, index: number) => (
    <BorderedListItem key={index}>
      <div className='row'>
        <div className={cn('col-12 col-lg-2', classes.educationItem)}>{item.yearObtained}</div>
        <div className={cn('col-12 col-lg-7', classes.educationItem)}>{item.certificateName}</div>
        <div className={cn('col-12 col-lg-3', classes.deliveredBy)}>{item.deliveredBy}</div>
      </div>
    </BorderedListItem>
  );
  const profAssociationsMapper = (item: string, index: number) => (
    <BorderedListItem key={index}>
      <div className={'row'}>
        <div className={cn('col-2', classes.number)}>{index + 1}.</div>
        <div className='col-10'>{item}</div>
      </div>
    </BorderedListItem>
  );
  const awardsMapper = (item: IAwards, index: number) => (
    <BorderedListItem key={index}>
      <div className={'row'}>
        <div className='col-2'>{item.year}</div>
        <div className='col-10'>{item.description}</div>
      </div>
    </BorderedListItem>
  );

  return (
    <Section number={'01'} label={t('additionalInfo.heroSection.sectionTitle')}>
      <Container className={classes.wrapper}>
        {!!education?.length && (
          <div className={cn('row', classes.rowWrapper)}>
            <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
              <MiscellaneousInformationTitle label={t('additionalInfo.heroSection.education')} type={MiscellaneousInformation.EDUCATION} />
            </div>
            <div className='col-xl-7 col-lg-7 offset-lg-1 col-md-6 col-sm-12'>
              <div className={classes.list}>{education.map(educationMapper)}</div>
            </div>
          </div>
        )}
        {!!profAssociations?.length && (
          <div className={cn('row', classes.rowWrapper)}>
            <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
              <MiscellaneousInformationTitle
                label={t('additionalInfo.heroSection.profAssociations')}
                type={MiscellaneousInformation.PROF_ASSOCIATIONS}
              />
            </div>
            <div className='col-xl-7 col-lg-7 offset-lg-1 col-md-6 col-sm-12'>
              <div className={classes.listBottom}>{profAssociations.map(profAssociationsMapper)}</div>
            </div>
          </div>
        )}
        {!!awards?.length && (
          <div className={cn('row', classes.rowWrapper)}>
            <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
              <MiscellaneousInformationTitle label={t('additionalInfo.heroSection.awards')} type={MiscellaneousInformation.AWARDS} />
            </div>
            <div className='col-xl-7 col-lg-7 offset-lg-1 col-md-6 col-sm-12'>
              <div className={classes.listBottom}>{awards.map(awardsMapper)}</div>
            </div>
          </div>
        )}
      </Container>
    </Section>
  );
};

export default HeroSection;
